module.exports = __webpack_public_path__ + "img/idcardBackUrl_shili.ef7405d0.png";